import React from "react";
import { ProdesegDropdownMenu } from "../prodeseg-dropdown/ProdesegDropdownMenu";
import { ProdesegDropdownToggle } from "../prodeseg-dropdown/ProdesegDropdownToggle";
import { ProdesegDropdown } from "../prodeseg-dropdown/ProdesegDropdown";
import { ProdesegButton, ProdesegButtonEnumSizes, ProdesegButtonEnumTypes } from "../ProdesegButton/ProdesegButton";
import { ReactComponent as IconMenu } from "../../assets/img/icon/menu/menu.svg";
import { SocialNetworkLinks } from "../../pages/home/SocialNetworkLinks";
import { PolicyMenu } from "../../pages/home/menu/PolicyMenu";
import { ReactComponent as IconHome } from "../../assets/img/icon/menu/home.svg";
import { LinkUnset } from "../LinkUnset";
import { useMenuItems } from "../../pages/home/menu/useMenuItems";
import { HOME_PATH } from "./navbar.constants";

export const ProdesegNavbarMenu: React.FC = () => {
    const menuItems = useMenuItems();
    return (
        <ProdesegDropdown>
            {state => (
                <>
                    <ProdesegDropdownToggle>
                        <ProdesegButton
                            type={ProdesegButtonEnumTypes.PrimaryLight}
                            Icon={IconMenu}
                            onlyIcon
                            isOutline
                            className={`${state.value ? "btn-hover" : "border-transparent"}`}
                        />
                    </ProdesegDropdownToggle>
                    <ProdesegDropdownMenu showCloseButton>
                        <div className={"d-flex flex-column w-100 gap-4 p-4"}>
                            <div className={"align-self-start"}>
                                <LinkUnset to={HOME_PATH} onClick={state.setFalse}>
                                    <ProdesegButton
                                        type={ProdesegButtonEnumTypes.Dark}
                                        size={ProdesegButtonEnumSizes.Small}
                                        Icon={IconHome}
                                        hideIconStart
                                    >
                                        Inicio
                                    </ProdesegButton>
                                </LinkUnset>
                            </div>
                            <PolicyMenu policies={menuItems} isSmall theme={"ligth"} />
                        </div>
                        <SocialNetworkLinks full />
                    </ProdesegDropdownMenu>
                </>
            )}
        </ProdesegDropdown>
    );
};
